module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "tab-demo",
    attrs: {
      "title": "Tab"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三']
    },
    model: {
      value: (_vm.default_index),
      callback: function($$v) {
        _vm.default_index = $$v
      },
      expression: "default_index"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "type",
      "description": "类型",
      "code": _vm.type_code
    },
    slot: "right"
  }, [_c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三'],
      "type": 'no_padding'
    },
    model: {
      value: (_vm.type_index),
      callback: function($$v) {
        _vm.type_index = $$v
      },
      expression: "type_index"
    }
  }), _vm._v(" "), _c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三'],
      "type": 'fix_width'
    },
    model: {
      value: (_vm.type_index),
      callback: function($$v) {
        _vm.type_index = $$v
      },
      expression: "type_index"
    }
  }), _vm._v(" "), _c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三'],
      "type": 'fix_width:25%'
    },
    model: {
      value: (_vm.type_index),
      callback: function($$v) {
        _vm.type_index = $$v
      },
      expression: "type_index"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "theme",
      "description": "主题",
      "code": _vm.theme_code
    },
    slot: "left"
  }, [_c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三']
    },
    model: {
      value: (_vm.theme_index),
      callback: function($$v) {
        _vm.theme_index = $$v
      },
      expression: "theme_index"
    }
  }), _vm._v(" "), _c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三'],
      "theme": 'card'
    },
    model: {
      value: (_vm.theme_index),
      callback: function($$v) {
        _vm.theme_index = $$v
      },
      expression: "theme_index"
    }
  }), _vm._v(" "), _c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三'],
      "theme": 'ticket',
      "type": 'fix_width'
    },
    model: {
      value: (_vm.theme_index),
      callback: function($$v) {
        _vm.theme_index = $$v
      },
      expression: "theme_index"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "trigger",
      "description": "触发类型",
      "code": _vm.trigger_code
    },
    slot: "right"
  }, [_c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三'],
      "trigger": 'hover'
    },
    model: {
      value: (_vm.trigger_index),
      callback: function($$v) {
        _vm.trigger_index = $$v
      },
      expression: "trigger_index"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "icon",
      "description": "图标",
      "code": _vm.icon_code
    },
    slot: "left"
  }, [_c('Tab', {
    attrs: {
      "data": ['Home', 'Cart', 'User']
    },
    model: {
      value: (_vm.icon_index),
      callback: function($$v) {
        _vm.icon_index = $$v
      },
      expression: "icon_index"
    }
  }), _vm._v(" "), _c('Tab', {
    attrs: {
      "data": [{
        name: 'Home',
        icon: 'home'
      }, {
        name: 'Cart',
        icon: 'shoppingcart'
      }, {
        name: 'User',
        icon: 'user'
      }]
    },
    model: {
      value: (_vm.icon_index),
      callback: function($$v) {
        _vm.icon_index = $$v
      },
      expression: "icon_index"
    }
  }), _vm._v(" "), _c('Tab', {
    attrs: {
      "data": [{
        name: 'Home',
        suffix_icon: 'home'
      }, {
        name: 'Cart',
        suffix_icon: 'shoppingcart'
      }, {
        name: 'User',
        suffix_icon: 'user'
      }]
    },
    model: {
      value: (_vm.icon_index),
      callback: function($$v) {
        _vm.icon_index = $$v
      },
      expression: "icon_index"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "activeStyle",
      "description": "选中样式",
      "code": _vm.style_code
    },
    slot: "right"
  }, [_c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三'],
      "active-style": {
        color: '#f02f45',
        borderBottomColor: '#f02f45'
      }
    },
    model: {
      value: (_vm.style_index),
      callback: function($$v) {
        _vm.style_index = $$v
      },
      expression: "style_index"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62f2fa71"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Tab.vue
// module id = 665
// module chunks = 0